import { render, staticRenderFns } from "./selectEducation.vue?vue&type=template&id=3498bdcd&"
import script from "./selectEducation.vue?vue&type=script&lang=js&"
export * from "./selectEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports